// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260450/js/" + chunkId + "." + {"44":"3bb301bf","225":"c4711c6b","481":"85fb2b53","486":"57edb995","770":"ea1d5c70"}[chunkId] + ".0.5967040271108142.chunk.js";
};